if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.classList.contains('fabric-sample-card__product-form')) {
        return this.addFabricSampleWithoutOpeningCart();
      }
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      let addRequest;
      const bundlePicker = this.closest('[id^="MainProduct-"]')?.querySelector('sp-product-addons');
      if (this.dataset.bundleAddon === 'true') {
        addRequest = this.addAccessoryWithParent(formData, config);
      } else if (bundlePicker && bundlePicker.dataset.parentFormId === this.form?.getAttribute('id') && bundlePicker.querySelector('[data-sp-addon][aria-checked="true"]')) {
        addRequest = this.addSelectedAccessories(formData, config, bundlePicker);
      } else {
        config.body = formData;
        addRequest = fetch(`${routes.cart_add_url}`, config);
      }

      addRequest
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            document.dispatchEvent(
              new CustomEvent("cart:error", {
                detail: {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.description,
                  message: response.message,
                },
              })
            );
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

        
            // VARIANT ADDED EVENT
          document.dispatchEvent(
            new CustomEvent("variant:add", {
              detail: {
                variant: {
                  id: formData.get("id"),
                },
                quantity: Number(formData.get("quantity") || 1),
                formElement: this.form,
                sectionId: this.dataset.source,
              },
            })
          );
          // -------------------------------------------

          fetch(`${routes.cart_url}.js`)
						.then((response) => {
							return response.text()
						})
						.then((state) => {
							const parsedState = JSON.parse(state)

							// dispatch cart:change for the entire basket
							document.dispatchEvent(
								new CustomEvent('cart:change', {
									detail: {
										cart: parsedState,
										sectionId: this.dataset.source,
									},
								})
							)
							// dispatch cart:change for the entire basket

						})
						.catch((error) => {
							console.error('Error fetching cart state:', error);
						})

            
          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    async addFabricSampleWithoutOpeningCart() {
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      if (this.closest('.fabric-sample-card')?.classList.contains('is-added')) return;
      const variantId = this.form.querySelector('[name="id"]')?.value;
      if (!variantId) return;
      this.submitButton.setAttribute('aria-disabled', 'true');
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
      try {
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id).join(','));
          formData.append('sections_url', window.location.pathname);
        }
        const response = await fetch(routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add fabric sample');
        if (this.cart && result.sections) {
          const drawerSource = this.cart.getSectionDOM(result.sections['cart-drawer'], '#CartDrawer');
          const updatedInner = drawerSource?.querySelector('.drawer__inner');
          const currentInner = this.cart.querySelector('.drawer__inner');
          if (updatedInner && currentInner) {
            currentInner.innerHTML = updatedInner.innerHTML;
            currentInner.className = updatedInner.className;
            this.cart.classList.remove('is-empty');
          }
          const iconSource = this.cart.getSectionDOM(result.sections['cart-icon-bubble'], '#cart-icon-bubble');
          const currentIcon = document.querySelector('#cart-icon-bubble');
          if (iconSource && currentIcon) currentIcon.innerHTML = iconSource.innerHTML;
        }
        document.dispatchEvent(new CustomEvent('variant:add', {
          detail: { variant: { id: variantId }, quantity: 1, formElement: this.form },
        }));
        const cartResponse = await fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart, source: 'fabric-sample-card' } }));
          document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count]').forEach((node) => {
            node.textContent = String(cart.item_count || 0);
          });
          document.querySelectorAll('.cart-count-bubble .visually-hidden').forEach((node) => {
            node.textContent = `${cart.item_count || 0} items`;
          });
        }
      } catch (error) {
        document.dispatchEvent(new CustomEvent('cart:error', {
          detail: { source: 'fabric-sample-card', productVariantId: variantId, message: error.message },
        }));
        this.handleErrorMessage(error.message);
      } finally {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
      }
    }

    buildLineItem(formData) {
      const item = {
        id: Number(formData.get('id')),
        quantity: Number(formData.get('quantity') || 1),
      };
      const properties = {};

      for (const [key, value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && value !== '') properties[match[1]] = value;
      }

      if (Object.keys(properties).length) item.properties = properties;
      if (formData.get('selling_plan')) item.selling_plan = Number(formData.get('selling_plan'));
      return item;
    }

    addSelectedAccessories(formData, config, picker) {
      const parentItem = this.buildLineItem(formData);
      const selected = [...picker.querySelectorAll('[data-sp-addon][aria-checked="true"]')];
      const unique = [...new Map(selected.map(option => [option.dataset.variantId, option])).values()];
      const accessories = unique.map(option => ({
        id: Number(option.dataset.variantId),
        quantity: parentItem.quantity,
        properties: {
          _bundle_accessory: 'true',
          'For sofa cover': picker.dataset.parentTitle,
          _parent_product_handle: picker.dataset.parentHandle,
        },
      }));
      const payload = { items: [parentItem, ...accessories] };
      if (this.cart) {
        payload.sections = this.cart.getSectionsToRender().map(section => section.id).join(',');
        payload.sections_url = window.location.pathname;
      }
      config.headers['Content-Type'] = 'application/json';
      config.body = JSON.stringify(payload);
      return fetch(routes.cart_add_url, config);
    }

    async addAccessoryWithParent(formData, config) {
      const parentForm = document.getElementById(this.dataset.bundleParentFormId);
      if (!parentForm) {
        config.body = formData;
        return fetch(`${routes.cart_add_url}`, config);
      }

      const parentData = new FormData(parentForm);
      const parentItem = this.buildLineItem(parentData);
      const accessoryItem = this.buildLineItem(formData);
      let parentAlreadyInCart = false;

      try {
        const cartResponse = await fetch(`${routes.cart_url}.js`);
        if (cartResponse.ok) {
          const cartState = await cartResponse.json();
          parentAlreadyInCart = cartState.items.some(
            (item) => Number(item.variant_id) === parentItem.id
          );
        }
      } catch (error) {
        console.warn('Unable to verify the parent product in the cart.', error);
      }

      const items = parentAlreadyInCart
        ? [accessoryItem]
        : [parentItem, accessoryItem];
      const payload = { items };

      if (this.cart) {
        payload.sections = this.cart.getSectionsToRender().map((section) => section.id).join(',');
        payload.sections_url = window.location.pathname;
      }

      config.headers['Content-Type'] = 'application/json';
      config.body = JSON.stringify(payload);
      return fetch(`${routes.cart_add_url}`, config);
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

